export function getInitials(_a) {
    var email = _a.email, firstName = _a.firstName, lastName = _a.lastName;
    var defaultInitials = "N/A";
    var userInitials = email === null || email === void 0 ? void 0 : email.toUpperCase().charAt(0);
    if (firstName || lastName) {
        var firstNameInitial = firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0).toUpperCase();
        var lastNameInitial = lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0).toUpperCase();
        userInitials = [firstNameInitial, lastNameInitial].join("");
    }
    return userInitials || defaultInitials;
}
export function hasPermission(user, permission) {
    if (!user) {
        return false;
    }
    return user.activeMembership.permissions.includes(permission);
}
